export default __webpack_public_path__ + "static/media/afd.f7dff2e1.png";